import { EntityType } from "@mapmycustomers/shared";

import { DateRange } from "@app/enum/dashboard/dateRanges";
import { ApiMethodName } from "@app/store/api/ApiService";
import EntityTypesSupportedInNewRecords from "@app/types/dashboard/cards/newRecords/EntityTypesSupportedInNewRecords";

export type Granularity = "day" | "hour" | "month" | "week";

export const granularityByDateRange: Record<DateRange, Granularity> = {
  [DateRange.DAY]: "hour",
  [DateRange.MONTH]: "day",
  [DateRange.QUARTER]: "week",
  [DateRange.WEEK]: "day",
  [DateRange.YEAR]: "month",
};

export interface DateAggregationItem {
  doc_count: number;
  key: number; // date in numeric format
}

export const fetchMethodByEntityType: Record<EntityTypesSupportedInNewRecords, ApiMethodName> = {
  [EntityType.COMPANY]: "fetchCompanies",
  [EntityType.DEAL]: "fetchDeals",
  [EntityType.PERSON]: "fetchPeople",
};
